import * as React from 'react';

import { Button, Theme, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { consts } from '../../../common/consts'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router-dom";
import { getPasswordStrength, PasswordStrength } from '../../../common/utility'

import { ReactComponent as SMALogo } from '../../../assets/svgs/smalogo.svg';
import { signIn } from '../loginHelpers';
import { useDispatch } from 'react-redux';
import api from '../../../store/api';


interface ResetPasswordConfirmedForTabletsProps {
    requestId: string,
    completeResetPassword: () => void
};


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        margin: 'auto',
    },
    inputs: {
        fontSize: 14,
    },
    buttonContainer: {
        textAlign: 'right'
    },
    button: {
        minWidth: 138,
        backgroundColor: '#FFB500',
        color: '#013270',
        borderRadius: 30,
        '&:hover': {
            color: '#0049a3',
            backgroundColor: '#013270',
        },
    },
    link: {
        color: '#F5F5F5',
        paddingLeft: 0,
        fontSize: 'small'
    },
    alertErrorRoot: {
        marginBottom: 20,
    },
    textFieldRoot: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            height: 50,
            '&:hover fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 10px',
        },
        borderRadius: '4px',

    },

    textFieldInput: {
        backgroundColor: '#ffffff',
        color: '#666666',
        fontSize: 16
    },

    logo: {
        maxWidth: 180,
        width: "100%",
        maxHeight: 162,
        cursor: "pointer",
      },
    contentContainer: {
        maxWidth: 1280,
        margin: 'auto',
        width: "100%",
        backgroundColor: '#001630',
        backgroundImage: 'url(https://smalive.wisdom.com.au/app/uploads/2021/06/bg-overlay-03-1.jpg)',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minHeight: '100vh'
    },

    headerBody: {
        padding: 25,
        display: 'flex',
    },
    widgetContent: {
        padding: 40,
        textAlign: 'center',
    },
    headerLogin: {
        marginTop: 30,
        paddingBottom: 0
    },
    headerLogo: {
    },
    heading: {
        fontSize: '100px',
        color: '#FFFFFF',
        fontWeight: 800,
        lineHeight: '1.2em',
        margin: 0,
    },
    loginText: {
        color: '#ffffff',
        marginBottom: 0,
        fontSize: 36
    },

}));

const PasswordStrengtLabel = (props: any) => {
    let fontColor = '#FF806F';
    if (props.passwordStrength === PasswordStrength.good) {
        fontColor = '#6DE99E';
    }
    else if (props.passwordStrength === PasswordStrength.moderate) {
        fontColor = '#FFEF4C';
    }
    return (
        <div style={{ marginLeft: 40,
            marginRight: 40,
            color: 'white' }}>
        <label>Password strength:{' '}</label>
        <label style={{ color: fontColor }}> {props.passwordStrength} </label >
    </div>
        
    )
}

function NewlineText(props: any) {
    const text = props.text;
    return <div style={{ whiteSpace: 'pre-wrap' }}>{text}</div>;
}

const ResetPasswordConfirmedForTablets: React.FC<ResetPasswordConfirmedForTabletsProps> = (props) => {
    const classes = useStyles();
    const { handleSubmit, errors, control, formState, trigger, watch } = useForm();
    const history = useHistory();
    const [passwordStrength, setPasswordStrength] = useState<PasswordStrength>(PasswordStrength.none);
    const [errorMessagePassword, setErrorMessagePassword] = useState(false);
    const [isValidRequest, setIsValidRequest] = useState<boolean>(true);
    const [showPassword, setShowPassword] = useState(false);
    const [resetPasswordStep, setResetPasswordStep] = useState(0);
    const [showConfirmedPassword, setShowConfirmedPassword] = useState(false);

    let passwordWatch = watch('password');



    React.useEffect(() => {
        validateRequest();
    }, [props.requestId])

    const LoginPage = () => {
        history.push('/login');
    }

    const validateRequest = async (): Promise<void> => {
        var res = await api.validateResetPasswordRequest(`requestId=${props.requestId}`);
        if (res == true) {
            setIsValidRequest(true)
        }
        else {
            setIsValidRequest(false);
        }
    }

    const resetPassword = async (data: any): Promise<void> => {
        let req: { [index: string]: string } = {
            'requestId': props.requestId,
            'password': data.password
        }
        await api.resetPassword('', req);
        setResetPasswordStep(1);
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleClickShowConfirmedPassword = () => {
        setShowConfirmedPassword(!showConfirmedPassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const emailValue = watch("email", "");
    React.useEffect(() => {
        if (/[0-9]+/.test(emailValue)) {
            trigger();
        }
    }, [emailValue])

    return (
        <>
            <div className={classes.root}>
                <div className={classes.contentContainer} style={{ width: '-moz-available' }}>
                    <Grid className={classes.headerBody} container>
                        <Grid item xs={4} className={classes.headerLogo}>
                            <SMALogo className={classes.logo} onClick={LoginPage} />
                        </Grid>
                        <Grid item xs={8} className={classes.headerLogin}>
                            <form onSubmit={handleSubmit(resetPassword)}>
                                <Grid spacing={3} container>
                                    <Grid item xs={12} className={classes.loginText}>
                                        Choose a password
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Controller
                                            control={control}
                                            render={({ onChange, onBlur, value, name }) => (<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                                classes: {
                                                    root: classes.textFieldInput
                                                },
                                                endAdornment: <InputAdornment position="end">
                                                    <IconButton style={{ color: 'lightgrey' }}
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}>
                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }}
                                                onBlur={onBlur}
                                                value={value}
                                                name={name}
                                                onChange={e => {
                                                    let pwdStrength = getPasswordStrength(e.target.value);
                                                    setPasswordStrength(pwdStrength);
                                                    onChange(e)
                                                }}
                                                variant='outlined'
                                                placeholder='Enter New Password'
                                                type={showPassword ? 'text' : 'password'}
                                                error={errors.password}
                                                helperText={errors.password ? errors.password.message : ""} />)}
                                            name='password'
                                            rules={{
                                                required: "Password is required",
                                                validate: (value) => {
                                                    let pwdStrength = getPasswordStrength(value);
                                                    if (pwdStrength !== PasswordStrength.good) {
                                                        setErrorMessagePassword(true);
                                                        return false;
                                                    }
                                                    else {
                                                        setErrorMessagePassword(false);
                                                        return true;
                                                    }
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Controller
                                            control={control}
                                            as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                                classes: {
                                                    root: classes.textFieldInput
                                                },
                                                endAdornment: <InputAdornment position="end">
                                                    <IconButton style={{ color: 'lightgrey' }}
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowConfirmedPassword}
                                                        onMouseDown={handleMouseDownPassword}>
                                                        {showConfirmedPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }}
                                                variant='outlined'
                                                placeholder='Re-type New Password'
                                                type={showConfirmedPassword ? 'text' : 'password'}
                                                error={errors.confirmedPassword}
                                                helperText={errors.confirmedPassword ? errors.confirmedPassword.message : ""} />}
                                            name='confirmedPassword'
                                            rules={{
                                                required: "Confirmed Password is required",
                                                validate: (value) => {
                                                    if (passwordWatch === value) {
                                                        return true;
                                                    }
                                                    else {
                                                        return "Confirmed Password does not match"
                                                    }
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={8}>
                                        {/* <PasswordStrengtLabel passwordStrength={passwordStrength}  /> */}
                                    </Grid>
                                    <Grid item xs={4} className={classes.buttonContainer}>
                                        <div className={classes.inputs}>
                                            <Button type='submit'
                                                disabled={formState.isSubmitting}
                                                className={classes.button}
                                                variant="contained">Save</Button>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {
                                            errorMessagePassword ?
                                                <div>
                                                    <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" className={classes.alertErrorRoot} >
                                                        Please enter a stronger password to continue. Try making your password longer, adding special characters (!@#$%^^&*), adding numbers and using upper case letters.
                                                    </Alert>
                                                </div>
                                                : null
                                        }
                                    </Grid>
                                </Grid>
                            </form>
                        </Grid>
                    </Grid>
                </div>
            </div>

        </>
    );
}

export default React.memo(ResetPasswordConfirmedForTablets)